import { memo } from 'react';
import { Tag, Box, Text, Flex, Avatar, HStack, VStack } from '@chakra-ui/react';

import SeeMoreButton from 'shared/SeeMoreButton';

import { DEFAULT_BORDER, DEFAULT_BORDER_RADIUS } from 'constants/global';

const SpecialistCard = ({ avatar, name, position, description, skills, popoverSkills }) => (
  <VStack
    w={{ mobile: 'full', xm: '342px', laptop: '440px' }}
    minH={{ mobile: '327px', laptop: '416px' }}
    p={{ mobile: '16px 24px 24px 16px', laptop: '16px 20px 32px 16px' }}
    border={DEFAULT_BORDER}
    borderColor="line.gray"
    borderRadius={DEFAULT_BORDER_RADIUS}
    gap="32px"
    align="start"
    position="relative"
  >
    <HStack gap={{ mobile: '16px', laptop: '20px' }}>
      <Avatar boxSize={{ mobile: '60px', laptop: '72px' }} src={avatar.src} />

      <VStack align="start">
        <Text textStyle="h2" fontWeight="500 !important">
          {name}
        </Text>

        <Text textStyle="h2" color="text.steelGray">
          {position}
        </Text>
      </VStack>
    </HStack>

    <VStack
      h="full"
      align="start"
      justifyContent={{ xm: 'space-between' }}
      gap={{ mobile: '20px', xm: '10px' }}
      pl="8px"
    >
      <Text textStyle="h1">{description}</Text>

      <Flex gap="8px" flexWrap="wrap">
        {skills.map((text, i) => (
          <Tag
            key={i}
            textStyle="h2"
            fontWeight="500"
            p={{ mobile: '6.5px 12px', laptop: '7.5px 16px' }}
            borderRadius="100px"
            bgColor="bg.grayLight"
            color="text.steelGray"
            fontSize={{ laptop: '18px', mobile: '12px' }}
          >
            {text}
          </Tag>
        ))}
      </Flex>
    </VStack>

    <Box
      position="absolute"
      bottom={{ mobile: '20px', xm: '27px', laptop: '40px' }}
      right={{ mobile: '20px', xm: '24px', laptop: '32px' }}
    >
      <SeeMoreButton dataToDisplay={popoverSkills} popoverHeader="Технические навыки:" />
    </Box>
  </VStack>
);

export default memo(SpecialistCard);
